<template>
    <div style="height: 100%">
        <RotaCheckInOutList v-show="!rotaAninhada" :reloadData="reloadData" />
        <router-view />
    </div>
</template>

<script>
import RotaCheckInOutList from '@/components/vendas/relatorios/relatorio-ven-check-in-out/RelatorioVenCheckInOutList.vue';

export default {
    name: 'RelatorioVenCheckInOutListRoute',

    beforeRouteUpdate(to, from, next) {
        this.rotaAninhada = to.name != 'relatorio-ven-check-in-out-list';
        if (from.name != 'relatorio-ven-check-in-out-list' && to.name == 'relatorio-ven-check-in-out-list') {
            this.reloadData = true;
            setTimeout(() => (this.reloadData = false), 300);
        }
        next();
    },
    components: {
        RotaCheckInOutList,
    },
    data() {
        return {
            rotaAninhada: false,
            reloadData: false,
        };
    },
    created() {
        this.rotaAninhada =
            this.$route.name.includes('relatorio-ven-check-in-out') &&
            this.$route.name != 'relatorio-ven-check-in-out-list';
    },
};
</script>
